const apiConfig = {
    // 开发环境
    development: {
        // baseURL: "http://192.168.110.85:9000",
        baseURL: "https://lianyudata.com",
        mapKey: "67968c82f27c7e2cb9f40c1a9aa3042b",
        secretKey: "37ce61ae86efa5ad82b649a277f5097c",
    },
    // 生产环境
    production: {
          // baseURL: "http://192.168.110.80:9000",
          baseURL: "https://lianyudata.com",
          mapKey: "67968c82f27c7e2cb9f40c1a9aa3042b",
          secretKey: "37ce61ae86efa5ad82b649a277f5097c",
    },
};
export default apiConfig[process.env.NODE_ENV];
